module.exports = __webpack_public_path__ + "img/img_origfac42x9.302ffc14.png";